import React from 'react';
import * as clevertapCustomersList from 'clevertap/customers/list';
import { Link } from 'react-router';
import styles from './LoyaltyBanner.css';

class LoyaltyBanner extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <Link to="/customers/loyalty" onClick={this._onBannerClick}>
          <img
            src={require('assets/images/loyalty-banner.png')}
            className={styles.banner}
          />
        </Link>
      </div>
    );
  }

  _onBannerClick = () => {
    clevertapCustomersList.loyaltyBannerClick();
  };
}

export default LoyaltyBanner;
